// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlogPage_blog-page__title__A9ZGw {
  font-size: 2rem;
  font-weight: 700;
  color: #445867;
  margin-bottom: 2rem;
}
.BlogPage_blog-page__message__BNoU7 {
  text-align: center;
  padding: 4rem 2rem;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  color: #64748b;
}`, "",{"version":3,"sources":["webpack://./src/pages/Blog/BlogPage.module.scss"],"names":[],"mappings":"AACE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,cAAA;AADJ","sourcesContent":[".blog-page {\n  &__title {\n    font-size: 2rem;\n    font-weight: 700;\n    color: #445867;\n    margin-bottom: 2rem;\n  }\n\n  &__message {\n    text-align: center;\n    padding: 4rem 2rem;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n    color: #64748b;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blog-page__title": `BlogPage_blog-page__title__A9ZGw`,
	"blog-page__message": `BlogPage_blog-page__message__BNoU7`
};
export default ___CSS_LOADER_EXPORT___;
